<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
  >
    <path
      d="M86.232 71.5262H12.357C11.8789 71.5262 11.4204 71.7162 11.0824 72.0542C10.7444 72.3923 10.5544 72.8507 10.5544 73.3288V76.9324H88.0331V73.3318C88.0335 73.0949 87.9872 72.8603 87.8968 72.6414C87.8065 72.4224 87.6739 72.2235 87.5067 72.0558C87.3394 71.8881 87.1408 71.755 86.922 71.6642C86.7033 71.5733 86.4688 71.5264 86.232 71.5262Z"
      fill="white"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M88.0331 76.9355H10.5486C11.1376 78.0605 12.0329 78.9958 13.131 79.6334C14.229 80.2711 15.4851 80.5851 16.7541 80.5392H81.8616C83.1205 80.5839 84.3663 80.2719 85.4556 79.6393C86.5449 79.0067 87.4333 78.0792 88.0183 76.9636L88.0331 76.9355Z"
      fill="#211F58"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M62.663 30.0913H35.1653"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M82.6268 54.7952V71.5352H15.9575V56.2372"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M30.5168 30.0913L34.4839 44.9032C34.543 45.1115 34.56 45.3294 34.5337 45.5442C34.5075 45.759 34.4386 45.9665 34.3311 46.1544C34.2236 46.3422 34.0797 46.5067 33.9078 46.6382C33.7359 46.7697 33.5394 46.8655 33.33 46.92L15.9575 51.5697"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M67.3287 30.0913L63.762 43.4065C63.7059 43.6089 63.6904 43.8204 63.7162 44.0287C63.7421 44.2371 63.8088 44.4384 63.9126 44.6209C64.0163 44.8035 64.1551 44.9638 64.3209 45.0926C64.4868 45.2214 64.6764 45.3162 64.879 45.3716L82.6267 50.1277"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M33.3272 46.92L15.9577 51.5697L11.9212 52.6513C11.7117 52.7072 11.4933 52.7213 11.2784 52.6927C11.0635 52.6641 10.8563 52.5933 10.6688 52.4844C10.4813 52.3756 10.3171 52.2308 10.1857 52.0584C10.0543 51.8859 9.95818 51.6893 9.90291 51.4796L3.05618 25.9824C3.00019 25.773 2.98605 25.5547 3.01459 25.3399C3.04312 25.125 3.11377 24.9179 3.22247 24.7304C3.33117 24.543 3.4758 24.3788 3.64806 24.2473C3.82033 24.1158 4.01685 24.0196 4.22636 23.9641L19.0383 20L21.2368 28.1986L29.4177 26.0001L30.517 30.0913L34.4841 44.9033C34.5432 45.1117 34.56 45.3298 34.5336 45.5448C34.5071 45.7598 34.438 45.9673 34.3302 46.1552C34.2224 46.3431 34.0782 46.5076 33.9059 46.6389C33.7337 46.7702 33.5369 46.8658 33.3272 46.92Z"
      fill="white"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M29.4175 26.0001L21.2366 28.1986L19.0381 20L29.4175 26.0001Z"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M29.4175 26.0001L21.2366 28.1986L19.0381 20L29.4175 26.0001Z"
      fill="#211F58"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M97.5288 34.326L92.9928 51.2448C92.8839 51.6525 92.6182 52.0007 92.2538 52.2135C91.8894 52.4263 91.4556 52.4865 91.047 52.381L82.6252 50.1278L64.879 45.3747C64.6764 45.3193 64.4868 45.2245 64.3209 45.0957C64.1551 44.9669 64.0163 44.8066 63.9126 44.624C63.8088 44.4415 63.7421 44.2402 63.7162 44.0318C63.6904 43.8235 63.7059 43.612 63.762 43.4096L67.3287 30.0944L69.1135 23.4087C69.1687 23.2062 69.2634 23.0166 69.392 22.8508C69.5207 22.685 69.6809 22.5462 69.8633 22.4424C70.0457 22.3386 70.2469 22.2719 70.4552 22.246C70.6635 22.2202 70.8748 22.2357 71.0771 22.2917L75.6898 23.5166L77.943 27.4275L96.4118 32.3638C96.8191 32.4775 97.1651 32.7474 97.3743 33.1149C97.5835 33.4824 97.639 33.9177 97.5288 34.326Z"
      fill="white"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M38.8579 52.6919C38.8579 55.4888 39.969 58.1712 41.9467 60.149C43.9245 62.1267 46.6069 63.2378 49.4038 63.2378C52.2008 63.2378 54.8832 62.1267 56.8609 60.149C58.8386 58.1712 59.9497 55.4888 59.9497 52.6919C59.9497 49.895 58.8386 47.2126 56.8609 45.2348C54.8832 43.2571 52.2008 42.146 49.4038 42.146C46.6069 42.146 43.9245 43.2571 41.9467 45.2348C39.969 47.2126 38.8579 49.895 38.8579 52.6919Z"
      fill="white"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M50.7222 56.6538V54.0176H53.3588C53.532 54.0176 53.7034 53.9835 53.8633 53.9172C54.0233 53.851 54.1686 53.7538 54.291 53.6314C54.4134 53.509 54.5105 53.3637 54.5768 53.2037C54.643 53.0438 54.6771 52.8724 54.6771 52.6993C54.6771 52.5261 54.643 52.3547 54.5768 52.1948C54.5105 52.0348 54.4134 51.8895 54.291 51.7671C54.1686 51.6447 54.0233 51.5476 53.8633 51.4813C53.7034 51.4151 53.532 51.381 53.3588 51.381H50.7222V48.7444C50.7164 48.3986 50.575 48.0689 50.3285 47.8265C50.0819 47.584 49.7499 47.4481 49.4041 47.4481C49.0583 47.4481 48.7263 47.584 48.4798 47.8265C48.2332 48.0689 48.0918 48.3986 48.086 48.7444V51.381H45.4494C45.0998 51.381 44.7645 51.5198 44.5172 51.7671C44.27 52.0143 44.1311 52.3496 44.1311 52.6993C44.1311 53.0489 44.27 53.3842 44.5172 53.6314C44.7645 53.8787 45.0998 54.0176 45.4494 54.0176H48.086V56.6538C48.0831 56.8287 48.115 57.0025 48.1799 57.165C48.2449 57.3275 48.3415 57.4754 48.4642 57.6002C48.5869 57.7249 48.7332 57.824 48.8945 57.8917C49.0559 57.9593 49.2291 57.9941 49.4041 57.9941C49.5791 57.9941 49.7523 57.9593 49.9137 57.8917C50.0751 57.824 50.2214 57.7249 50.3441 57.6002C50.4668 57.4754 50.5634 57.3275 50.6283 57.165C50.6932 57.0025 50.7252 56.8287 50.7222 56.6538Z"
      fill="#D9EDE2"
      stroke="#211F58"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
